var canvas, canvas2, text, fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 2000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4,img,newImg,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 493, sizeB1H = 604,
    sizeB2W = 155, sizeB2H = 155;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');

$(document).ready(function() {

  currentImage = null; 

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      currentImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Black Base (Big Size: Height 8 Width 5.5 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});




// let borderImg = document.querySelector("#border_qr");
// let QrplateBorder = new fabric.Image(borderImg, {
//   left: 1689,
//   top: 860,
//   scaleX: 0.22,
//   scaleY: 0.22,
//   selectable: false
// });
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

// window['canvas2'].add(QrplateBorder);
addModify(window['canvas2']);






// $(document).ready(function () {
//   let currentImage = null;

//   function loadImage(url) {
//     if (currentImage) {
//       canvas2.remove(currentImage);
//     }

//     fabric.Image.fromURL(
//       url,
//       function (img) {
//         img.set({
//           left: 1220,   
//           top: 620,
//           scaleX: 1.3,
//           scaleY: 1.3,
//           selectable: false
//         });

//         img.scale(1.15);
//         canvas2.add(img);
//         // canvas2.sendToBack(img);
//         currentImage = img;

//         canvas2.renderAll();
//       },
//       { crossOrigin: 'anonymous' }
//     );
//   }

//   function setActiveBackground($btn) {
//     // UI
//     $('#background_design a').removeClass('active');
//     $btn.addClass('active');

//     // Load image
//     const url = $btn.find('img').attr('data-src');
//     if (url) loadImage(url);

//     // Cart value
//     backgroundDesign = $btn.data('title');

//     // Text style sync
//     // applyTextStyleFromButton($btn);
//   }

//   // =====================
//   // DEFAULT LOAD
//   // =====================
//   const $defaultBtn = $('#icon1');
//   setActiveBackground($defaultBtn);

//   // =====================
//   // CLICK HANDLER
//   // =====================
//   $('#background_design').on('click', 'a', function (e) {
//     e.preventDefault();
//     setActiveBackground($(this));
//   });
// });




window['placeholderimg1'] = new fabric.Rect({
  left: 321.5,
  top: 629,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});



// create initial music_code from the DOM image and store it on window
// let spotify = document.querySelector("#spotify_music_code");
// let initMusic = new fabric.Image(spotify, {
//   left: 1799,
//   top: 970,
//   scaleX: 0.3,
//   scaleY: 0.3,
//   selectable: false
// });
// window['music_code'] = initMusic;
// window['canvas2'].add(window['music_code']);
// window['canvas2'].renderAll();

// upload replaces window['music_code']
// document.getElementById('image_upload_second').addEventListener('change', function(e) {
//   var canvas = window['canvas2'];
//   var reader = new FileReader();

//   reader.onload = function(evt) {
//     fabric.Image.fromURL(evt.target.result, function(newImg) {
//       // remove old music image (if present)
//       if (window['music_code'] && canvas.getObjects().includes(window['music_code'])) {
//         canvas.remove(window['music_code']);
//       }

//       // scale new image to fit placeholder sizes
//       newImg.set({
//         left: 1799,
//         top: 970,
//         selectable: false
//       });
//       // uniform scale to fit width/height (use whichever you want)
//       newImg.scaleX = (sizeB2W / newImg.width);
//       newImg.scaleY = (sizeB2H / newImg.height);

//       // save reference and add
//       window['music_code'] = newImg;
//       canvas.add(window['music_code']);
//       canvas.renderAll();
//     });
//   };

//   reader.readAsDataURL(e.target.files[0]);
// });



window['canvas2'].add(window['placeholderimg1']);



var heartimg,heartBorder,imgRatio,clipPath,clipRatio,clipWidth = 750;
    heartPathString = "M0,0h500v500H0V0z";
var heartClip = new fabric.Path(heartPathString, {
  left: 321.5,
  top: 629,
  originX: 'center',
  originY: 'center',
  fill: 'transparent',
  absolutePositioned: true
});
heartClip.scaleToWidth(clipWidth);
canvas2.add(heartClip);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg1'];
  available_height = img.height;
  sizeCrop = '0.82';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target, '#image1');
});


// Load the image and apply the clipPath
fabric.Image.fromURL('placeholder_lamp.png?v=1739800516', function(heartimg){
  heartimg.set({ crossOrigin: 'anonymous' });
  heartimg.scaleToWidth(clipWidth);
  heartimg.set({
    left: 321.5,
    top: 629,
    originX: 'center',
    originY: 'center',
    selectable: false,
    clipPath: heartClip
  });
  
  canvas2.add(heartimg);
  canvas2.renderAll();
}, { crossOrigin: 'anonymous' });






function updateCanvasLayout(showImage){

    const layout = showImage ? layouts.withImage : layouts.noImage;

    // Save current layout widths
    currentTitleWidth = layout.titleWidth;
    currentQuoteWidth = layout.quoteWidth;

    text1Page.set({
        left: layout.titleX,
        originX: 'center',
        textAlign: 'center'
    });

    text2Page.set({
        left: layout.quoteX,
        originX: 'center',
        textAlign: 'center'
    });

    // Re-fit using current layout
    fitTextToWidth(text1Page, currentTitleWidth);
    fitTextToBox(text2Page, currentQuoteWidth, 220);

    placeholderimg1.visible = showImage;

    if(window.heartimg){
        window.heartimg.visible = showImage;
    }

    canvas2.renderAll();
}


const layouts = {

    withImage: {
        titleX: 1230,
        quoteX: 1230,
        titleWidth: 1230,
        quoteWidth: 1200
    },

    noImage: {
        titleX: 1000,
        quoteX: 1000,
        titleWidth: 1750,
        quoteWidth: 1700
    }

};

// Current layout widths
let currentTitleWidth = layouts.withImage.titleWidth;
let currentQuoteWidth = layouts.withImage.quoteWidth;




window['text1Page'] = new fabric.Text('Nexa Workspace', {
  left: 1225,
  top: 505,
  fontSize: 130,
  fontFamily: 'Berlin SansFB',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false,
  selectable: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Nexa Workspace') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 130; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], currentTitleWidth);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



var maxWidth = 1200;
var maxHeight = 220;

var para = "Great work begins with a focused mind\na clear vision, and the courage to start" ;

window['text2Page'] = new fabric.Text(para,{
  left: 1225,
  top: 705,
  fontSize: 75,
  fontFamily: 'Berlin SansFB',
  fill: 'black',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false,
  selectable: false,
  originX: 'center',
  textAlign: 'center'
});

var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text2Page']);

var minFontSize = 20;
var maxFontSize = 75;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Kabir Sing') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  fitTextToBox(window['text2Page'], currentQuoteWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75504472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl) {
  const canvas = window['canvas2']; // ensure consistent canvas reference

  // Remove any previous temporary img var (if you used 'img' elsewhere)
  if (typeof img !== 'undefined' && canvas.getObjects().includes(img)) {
    canvas.remove(img);
  }

  // Remove previously added heart image (global)
  if (window['heartimg'] && canvas.getObjects().includes(window['heartimg'])) {
    canvas.remove(window['heartimg']);
  }

  // Load new image and save it to the global window['heartimg']
  fabric.Image.fromURL(imgurl, function(loadedImg) {
    loadedImg.set({ crossOrigin: 'anonymous' });

    // Position center (match your placeholder / clip coordinates)
    loadedImg.set({
      left: 321.5,
      top: 629,
      originX: 'center',
      originY: 'center',
      selectable: false
    });

    // Scale to target height (available_height) or width. Use whichever you need.
    // NOTE: available_height must be defined and numeric
    if (typeof available_height === 'number' && available_height > 0) {
      loadedImg.scaleToHeight(available_height);
    } else if (typeof sizeB1W === 'number' && sizeB1W > 0) {
      loadedImg.scaleToWidth(sizeB1W);
    }

    // Apply clip (heartClip should already exist in canvas)
    loadedImg.clipPath = heartClip;

    // Save as global so other functions can reference it
    window['heartimg'] = loadedImg;

    // Add to the same canvas
    canvas.add(window['heartimg']);

    // Make sure ordering is correct
    if (typeof simpleImage !== 'undefined') simpleImage.bringToFront();
    if (window['text1Page']) window['text1Page'].bringToFront();

    canvas.renderAll();
  }, { crossOrigin: 'anonymous' });
}




function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});


document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas');
  fontSize = '';
  activeCOLOR = '';
  fontFamily = jQuery(this).val();
  canvas = window[fontID];
  updateFont(window['text1Page'],fontFamily,fontSize,activeCOLOR);
  updateFont(window['text2Page'],fontFamily,fontSize,activeCOLOR);
  fitTextToWidth(window['text1Page'], currentTitleWidth);
  fitTextToBox(window['text2Page'], currentQuoteWidth, maxHeight);
});



function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];

  temp_images.push(jQuery('#crop_button').attr('data-cropped'));
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties[User Upload '+int+']">');
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,backgroundDesign,spotifyImage,songName,singerName,chooseFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    // resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 510;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(currentImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    backgroundDesign = backgroundDesign;
    spotifyImage = jQuery('.spotify_image option:selected').val();
    songName = jQuery('.song_name input').val();
    singerName = jQuery('.singer_name textarea').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#backgroundDesign').val(backgroundDesign);
      jQuery('#spotifyImage').val(spotifyImage);
      jQuery('#songName').val(songName);
      jQuery('#singerName').val(singerName);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});





function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(currentImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}